import Unit from './Unit';

export default class Roster {
  cost;
  units;

  constructor(parsedXML) {
    if (parsedXML.attributes.gameSystemName.includes('Warhammer 40,000: Kill Team (2021)')) {
      // console.log("SYSTEM!", parsedXML.getElementsByTagName('selection'))
      parsedXML.children.map((data) => {
        if (data.name === 'costs') {
          this.cost = parseInt(data.children[0].attributes.value);
        }
        if (data.name === 'forces') {
          this.buildUnits(data.children[0].children[0].children.slice(1));
        }
      });
    } else {
      throw new Error('Submitted file is not a Kill Team 2021 roster.');
    }
  }

  buildUnits(data) {
    this.units = data.map((unit) => new Unit(unit));
  }
}